import React from 'react';

export interface ITextAreaProps {
    name: string;
    onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
    maxLength?: number;
    placeholder?: string;
    value?: string | number;
    title?: string;
    error?: string;
    showError?: boolean;
    required?: boolean;
    className?: string;
    disabled?: boolean;
    onBlur?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
    customLabel?: boolean;
}

interface ITextAreaBaseProps extends ITextAreaProps {
    type: string;
}

const TextAreaBase = ({
    type,
    name,
    onChange,
    maxLength,
    placeholder,
    className,
    value,
    title,
    error,
    showError,
    disabled,
    onBlur,
}: ITextAreaBaseProps) => {
    let wrapperClass = '';
    if (error && error.length > 0) {
        wrapperClass += ' has-error';
    }

    return (
        <div className={wrapperClass}>
            <textarea
                name={name}
                className={className}
                placeholder={placeholder}
                maxLength={maxLength}
                value={value}
                title={title}
                onChange={onChange}
                disabled={disabled}
                readOnly={disabled}
                onBlur={onBlur}
            />
            {error && <div className="alert alert-danger">{error}</div>}
        </div>
    );
};

export default TextAreaBase;
